import { createApi } from '@reduxjs/toolkit/query/react';

import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { mapObjectKeysToCamelCase } from '@/utils/object-mapper-utils';

export const refinanceApi = createApi({
  reducerPath: 'refinanceApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getAdminRefinanceRequestList: builder.query<
      ApiResponse<any>,
      {
        filter: string;
        page: number;
        pageSize?: number;
        email?: string;
        brokerId?:string,
        dateRange?: [string, string] | null;
      }
    >({
      query: ({ filter, page, email, dateRange, brokerId, pageSize = 10 }) => {
        return {
          url: `v1/online-assessment/refinance/list`,
          method: 'GET',
          params: {
            filter,
            page: page,
            pageSize,
            ...(email ? { email } : {}),
            ...(brokerId && {brokerId}),
            ...(dateRange && {
              startDate: dateRange[0],
              endDate: dateRange[1],
            }),
          },
        };
      },
    }),
    getRefinanceStepsData: builder.query<ApiResponse<any>, { id: string }>({
      query: ({ id }) => {
        return {
          url: `v1/online-assessment/refinance/step-data/${id}`,
          method: 'GET',
        };
      },
    }),
    getRefinanceApplicationStepData: builder.query<
      any,
      { id: number; step: string }
    >({
      query: ({ id, step }) => {
        return {
          url: `v1/online-assessment/refinance/step-data/${id}/${step}`,
          method: 'GET',
        };
      },
      transformResponse: (response: any) => {
        return mapObjectKeysToCamelCase(response?.data?.data);
      },
    }),
  }),
});

export const {
  useGetAdminRefinanceRequestListQuery,
  useGetRefinanceStepsDataQuery,
  useGetRefinanceApplicationStepDataQuery,
} = refinanceApi;
